import { Component, inject, Input } from '@angular/core';
import {
    ControlContainer,
    FormControl,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { ElementWithOptionsModel } from '../../../models/clientsform/element-with-options';
import { LocalizationService } from '../../../services/localization.service';
import { TranslationComponent } from '../../translation/translation.component';

@Component({
    selector: 'apcam-select-element',
    imports: [
        MatSelectModule,
        ReactiveFormsModule,
        TranslatePipe,
        TranslationComponent,
    ],
    templateUrl: './select-element.component.html',
    styleUrl: './select-element.component.scss',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: () => inject(ControlContainer, { skipSelf: true }),
        },
    ],
})
export class SelectElementComponent {
    @Input({ required: true })
    public formcontrolName!: string;

    @Input({ required: true })
    public inputConfig!: ElementWithOptionsModel;

    protected get input() {
        return this.controlContainer.control?.get([
            this.formcontrolName,
        ]) as FormControl;
    }

    protected get defaultLang() {
        return this.localizationService.defaultLanguage;
    }

    private readonly controlContainer = inject(ControlContainer);
    private readonly localizationService = inject(LocalizationService);
}
